// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"f47dbd40","279":"8399ac3b","502":"c8c06a50","614":"195f856c"}[chunkId] + ".chunk.js";
};